import { useState } from "react";

import { apiRoot } from "../constants";
import { useAuth } from "./useAuth";

const useSubmission = () => {
  const [error, setError] = useState(false);
  const { authed, token } = useAuth();

  const submitRestaurant = (data) => {
    let headers;
    if (authed) {
      headers = {
          Authorization: "Token " + token,
          "Content-Type": "application/json",
        };
    } else {
         headers = {
          "Content-Type": "application/json",
        };
    }
    return new Promise((res) => {
      fetch(`${apiRoot}/submissions`, {
        method: "POST",
        body: JSON.stringify(data),
        headers,
      })
        .then((response) => {
          if (response.status !== 201) {
            setError(true);
            return;
          }
          return response.json();
        })
        .then((json) => {
          res(json);
        })
        .catch((err) => {
          setError(true);
        });
    });
  };

  return {
    submitRestaurant,
    error,
  };
};

export default useSubmission;
